/**
 * Admin Service - Servicio de administración
 */

import { ApiServiceBase } from '../core/ApiService';
import type { Document } from '../types/document';
import logger from '../../../utils/simpleLogger';

export class AdminService extends ApiServiceBase {
  /**
   * Sube un documento para admin (endpoint simplificado)
   */
  async uploadAdminDocument(
    formData: FormData
  ): Promise<{ success: boolean; document?: Document; message?: string }> {
    try {
      const response = await this.request('/admin/upload', {
        method: 'POST',
        body: formData,
      });
      return {
        success: true,
        document: (response as any).document,
        message: (response as any).message,
      };
    } catch (error) {
      logger.error('❌ [API] uploadAdminDocument failed', error);
      return {
        success: false,
        message: error instanceof Error ? error.message : 'Error al subir documento',
      };
    }
  }

  /**
   * Obtiene todos los documentos (admin)
   */
  async getAdminDocuments(): Promise<{ documents: Document[] }> {
    return this.request('/admin/documents');
  }

  /**
   * Elimina todos los documentos (admin)
   */
  async deleteAllDocuments(): Promise<{
    success: boolean;
    deleted_count: number;
    files_deleted: number;
    message: string;
  }> {
    return this.request('/admin/documents/delete-all', {
      method: 'DELETE',
    });
  }

  /**
   * Elimina documentos en lote (admin)
   */
  async bulkDeleteDocuments(documentIds: string[]): Promise<{
    success: boolean;
    deleted_count: number;
    message: string;
  }> {
    return this.request('/admin/documents/bulk-delete', {
      method: 'DELETE',
      body: JSON.stringify({ document_ids: documentIds }),
    });
  }
}
